// A task's tracking list (migration 078) — the strip on the board, the panel it opens,
// the setup in the task dialog. One section, `lists`.
export default {
  lists: {
    nav: 'רשימות',
    newWithTask: 'משימה עם רשימה',
    doneGroup: 'בוצעו',
    openTab: 'פתוחות',
    doneTab: 'שבוצעו',
    emptyOpen: 'אין רשימות פתוחות',
    emptyDone: 'אין רשימות שבוצעו',
    section: 'רשימה',
    add: 'הוספת רשימה',
    open: 'פתיחת הרשימה',
    definition: 'מצבים ועמודות',
    remove: 'הסרת הרשימה',
    removeShort: 'הסרה',
    removeTitle: 'הסרת הרשימה',
    removeQuestion: (n) => `להסיר את הרשימה ואת ${n} השורות שבה?`,
    deleteWithTask: (n) => `הרשימה שבמשימה (${n} שורות) תימחק איתה.`,

    shape: 'סוג',
    states: 'מצבים',
    columns: 'עמודות',
    addState: '＋ מצב',
    addColumn: '＋ עמודה',
    finished: 'טופל',
    moveUp: 'הזזה למעלה',
    removeRow: 'הסרה',
    stateLabel: 'שם המצב',
    columnLabel: 'שם העמודה',
    toneLabel: 'צבע',
    kindLabel: 'סוג',
    tones: { green: 'ירוק', amber: 'כתום', blue: 'כחול', red: 'אדום', gray: 'אפור' },
    kinds: { text: 'טקסט', phone: 'טלפון', email: 'דוא"ל', date: 'תאריך', number: 'מספר' },

    // The starting shapes. The first state of each is where a new row starts.
    shapes: {
      invitees: {
        label: 'מוזמנים לאירוע',
        states: ['טרם ענה', 'מגיע', 'אולי', 'לא מגיע'],
        columns: ['טלפון', 'כלי תקשורת', 'מלווים'],
      },
      press: {
        label: 'עיתונאים',
        states: ['טרם פנינו', 'נשלח', 'חזר אלינו', 'פרסם', 'לא רלוונטי'],
        columns: ['כלי תקשורת', 'טלפון', 'דוא"ל'],
      },
      suppliers: {
        label: 'ספקים',
        states: ['טרם אושר', 'אושר', 'בוטל'],
        columns: ['טלפון', 'מה מספק'],
      },
      deliveries: {
        label: 'משלוחים',
        states: ['טרם נשלח', 'נשלח', 'נמסר'],
        columns: ['כתובת', 'טלפון'],
      },
      blank: {
        label: 'רשימה ריקה',
        states: ['לא טופל', 'בטיפול', 'הושלם'],
        columns: [],
      },
    },

    name: 'שם',
    state: 'מצב',
    note: 'הערה',
    updated: 'עודכן',
    all: 'הכול',
    search: 'חיפוש',
    addName: 'הוספת שם',
    addButton: 'הוספה',
    rows: (n) => `${n} שורות`,
    noMatch: 'אין שורות מתאימות',
    allDone: 'הכול טופל',
    deleteRow: 'מחיקת השורה',
    choose: 'בחירת מצב',
    select: 'בחירה',
    selectAll: 'בחירת הכול',
    selected: (n) => `${n} נבחרו`,
    copy: 'העתקה ממשימה אחרת',
    copyPick: 'מאיזו משימה',
    copyRows: (n) => `כולל השורות (${n})`,
    doneOn: 'בוצע',

    completeTitle: 'סימון כבוצע',
    leftOpen: (n) => `נשארו ${n} פתוחים`,
    completeConfirm: 'סימון כבוצע',

    // How the list is organised (079) — saved on the list, the same for everyone.
    groupBy: 'קבץ לפי',
    groupNone: 'ללא',
    groupState: 'מצב',
    sortBy: 'סדר',
    sortAdded: 'לפי הוספה',
    sortName: 'לפי שם',
    allGroups: 'כל הקבוצות',
    noValue: (column) => `ללא ${column}`,
    // A group's heading: its rows, and how many are in a finished state.
    groupMeta: (n, done) => (done ? `${n} · ${done} טופלו` : `${n}`),
    selectGroup: (group) => `בחירת ${group}`,

    // Printing, or saving as PDF through the browser's print dialog.
    print: 'הדפסה / PDF',
    printGo: 'הדפסה / שמירה כ־PDF',
    printColumns: 'עמודות',
    printCheck: 'עמודת סימון',
    printed: 'הודפס',
    printShowing: (n, total) => `${n} מתוך ${total} שורות`,
    printGroup: 'קבוצה',
    printSearch: 'חיפוש',
    printBack: 'חזרה לרשימה',
  },
};
